import { render, staticRenderFns } from "./jcProductDialog.vue?vue&type=template&id=6d272990&scoped=true"
import script from "./jcProductDialog.vue?vue&type=script&lang=js"
export * from "./jcProductDialog.vue?vue&type=script&lang=js"
import style0 from "./jcProductDialog.vue?vue&type=style&index=0&id=6d272990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d272990",
  null
  
)

export default component.exports